import React from 'react';
import { Activity } from 'lucide-react';

interface EmptyStateProps {
  title?: string;
  description?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No data available',
  description = 'There is no data to display for the selected period.'
}) => (
  <div className="flex flex-col items-center justify-center py-12 text-gray-400">
    <Activity className="h-10 w-10 mb-3" />
    <p className="text-sm font-medium text-gray-500">{title}</p>
    <p className="text-xs text-gray-400 mt-1">{description}</p>
  </div>
);

export default EmptyState;
